import { render, staticRenderFns } from "./DataTableUpperButtons.vue?vue&type=template&id=15806acb&scoped=true&"
import script from "./DataTableUpperButtons.vue?vue&type=script&lang=js&"
export * from "./DataTableUpperButtons.vue?vue&type=script&lang=js&"
import style0 from "./DataTableUpperButtons.vue?vue&type=style&index=0&id=15806acb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15806acb",
  null
  
)

export default component.exports